import { Link } from "@inertiajs/react"
import { Trophy } from "lucide-react"
import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"
import { creatorMissionsPath } from "@/routes"

/**
 * OKS-519 — §13 empty state (Figma `55:2232`).
 *
 * Shown when no crew member is ranked this week (or the brand has no
 * crew). Centred illustration + headline + body + a primary "Find a
 * mission" CTA routing to `/missions` (js-routes helper). Covers both
 * `no_crew` and `no_xp_in_window` — the copy is identical (the board is
 * empty either way; the path forward is the same).
 */
export function LeaderboardEmpty() {
  const { t } = useTranslation()

  return (
    <div
      data-testid="creator-leaderboard-empty"
      className="flex flex-col items-center gap-4 px-6 py-12 text-center"
    >
      <div className="bg-muted flex size-16 items-center justify-center rounded-full">
        <Trophy className="text-muted-foreground size-8" aria-hidden="true" />
      </div>
      <div className="flex flex-col gap-1">
        <h2 className="text-lg font-semibold">
          {t("leaderboard.creator.empty_title")}
        </h2>
        <p className="text-muted-foreground max-w-xs text-sm">
          {t("leaderboard.creator.empty_body")}
        </p>
      </div>
      <Button asChild>
        <Link href={creatorMissionsPath()}>
          {t("leaderboard.creator.empty_cta")}
        </Link>
      </Button>
    </div>
  )
}
